import React, { useEffect, useState } from "react";
import { useAppState } from "../contexts/AppContext";
import DashboardWidget from "../components/DashboardWidget";
import { get } from "../helpers/Dashboard";
import dayjs from "dayjs";
import Clients, { getClients } from "../helpers/Clients";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import Invoices from "../helpers/Invoices";
import { getVendors } from "../helpers/Vendors";
import Users from "../helpers/Users";


export default function UserCreate() {
    const { appState } = useAppState();
    const [vendors, setVendors] = useState<Array<any>>([])
    const { register, handleSubmit } = useForm();
    const navigate = useNavigate()

    useEffect(() => {
        getVendors().then((result) => {
            setVendors(result)
        })
    }, [])


    const onSubmit = handleSubmit((values) => {
        if (values.vendorId === "") {
            values.vendorId = vendors[0].id
        }

        if (values.vendorId === "") {
            console.error('Vendor id is null');

            return;
        }

        Users.create({
            name: values.name,
            email: values.email,
            password: values.password,
            vendorId: values.vendorId,
        }).then(() => {
            navigate('/users')
        })
    });

    return (
        <>
            <div className="flex justify-between items-center">
                <h1 className="text-xl">Users \ New user</h1>
            </div>
            <div className="mt-3 p-3 rounded bg-white">
                <form className="" onSubmit={onSubmit}>
                    <div className="space-y-4">
                        <select
                            required
                            {...register('vendorId')}
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6">
                            {vendors.map((vendor) => (<option value={vendor.id}>{vendor.name}</option>))}
                        </select>
                        <input
                            {...register('name')}
                            placeholder="Name"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                        <input
                            {...register('email')}
                            placeholder="Email"
                            type="email"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />
                        <input
                            {...register('password')}
                            placeholder="Password"
                            type="password"
                            required
                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-blue-600 sm:text-sm/6"
                        />

                        <div className="mt-6 flex items-center justify-end gap-x-6">
                            <Link to="/users" className="text-sm/6 font-semibold text-gray-900">
                                Cancel
                            </Link>
                            <button
                                type="submit"
                                className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-blue-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
